/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useEffect,
  useRef,
  useState
} from 'react';

import Lottie from "lottie-react";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import {
  toAbsoluteUrl
} from '../../../_metronic/helpers';

import paymentAnimation from '../../../_metronic/assets/animations/payment.json';
import paymentRejectedAnimation from '../../../_metronic/assets/animations/paymentRejected.json';
import LoadingBranch from '../../modules/loading/LoadingBranch';
import LoadingContent from '../../modules/loading/LoadingContent';

import SupportOption from 'app/pages/HelpCenter/SupportOption';
import PaymentPage from 'app/pages/Payment/PaymentPage';

import {
  formatLongDateToDate,
  parseWeekDays
} from 'app/services/dates';


import {
  getBrandImage,
} from "app/utils/Labels";

import {
  formatMoney,
} from 'app/services/intFormat';

import {
  fetchSignature
} from 'app/services/signatures';
import CancelModal from 'app/utils/CancelModal';

const Signature = () => {
  const { auth, signatures } = useSelector((state : any) => ({
    auth: state.auth,
    signatures: state.signatures,
  }), shallowEqual);

  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [signature, setSignature] = useState<any>({});
  const [invoice, setInvoice] = useState<any>({});
  const [openCancelSignature, setOpenCancelSignature] = useState<any>(false);
  const [openPayment, setOpenPayment] = useState<any>(false);
  const [payment, setPayment] = useState<any>({});
  const [invoices, setInvoices] = useState<any>([]);

  const lottieRef = useRef<any>();

  useEffect(() => {
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify({ type: 'app-modal-open' }))
    }
    return () => {
      if ((window as any).ReactNativeWebView) {
        (window as any).ReactNativeWebView.postMessage(JSON.stringify({ type: 'app-modal-close' }))
      }
    }
  }, []);

  useEffect(() => {
    setSignature({});
    setInvoices([]);
    setInvoice({});
    setPayment({});

    getSignature();
  }, []);

  useEffect(() => {
    if (signature?.id) {
      let currentInvoice = {};

      if (signature.relationships.invoices.length == 1) {
        currentInvoice = signature.relationships.invoices[0];
      } else {
        currentInvoice = signature.relationships.invoices.find((value) => value.attributes.is_current == true);
      }

      setInvoice(currentInvoice);
      setInvoices(signature.relationships.invoices);
    }
  }, [signature]);

  useEffect(() => {
    if (invoice && invoice.id) {
      if (invoice.relationships.payments && invoice.relationships.payments[0] && invoice.relationships.payments[0].id) {
        let firstPayment = invoice.relationships.payments[0];
        setPayment(firstPayment);
      }
    }
  }, [invoice]);

  useEffect(() => {
    if(!auth.user) {
      navigate('/')
    }
  }, [auth]);

  const cancel = () => {
    setOpenCancelSignature(false);
  }

  const getSignature = () => {
    dispatch<any>(fetchSignature(id)).then(response => {
      setSignature(response);
    }).catch((error) => {
      navigate('/assinaturas/clubinho');
    });
  }

  const getPaymentMethod = () => {
    if (invoice?.attributes) {
      let paymentMethod = invoice.attributes.payment_method;

      if (paymentMethod === 'credit') {
        return `Consumo de crédito`;
      }

      if (paymentMethod === 'pix') {
        return <div className="flex-column">
            <img src={toAbsoluteUrl('/media/custom/pix.png')} width="25" alt='Pix' />
            <span className="ms-3">PIX</span>
          </div>
      }

      if (paymentMethod === 'credit_card') {
        if (invoice.relationships.payments &&
          invoice.relationships.payments[0] &&
          invoice.relationships.payments[0].relationships &&
          invoice.relationships.payments[0].relationships.client_card &&
          invoice.relationships.payments[0].relationships.client_card.attributes
        ) {
          return <div className="flex-column">
            <img src={toAbsoluteUrl(`/media/custom/${getBrandImage(invoice.relationships.payments[0].relationships.client_card.attributes.brand)}`)} width="25" alt='Pix' />
            <span className="ms-3"> ••• {invoice?.relationships?.payments[0].relationships.client_card.attributes.last_four_digits}</span>
          </div>
        }
      }
    }

    return '-';
  }

  const getClientCard = () => {
    if (signature?.relationships?.client_card?.attributes) {
      return <div className='flex-row'>
        <div className="flex-column">
          <img src={toAbsoluteUrl(`/media/custom/${getBrandImage(signature?.relationships?.client_card?.attributes.brand)}`)} width="25" alt='Pix' />
          <span className="ms-3"> ••• {signature?.relationships?.client_card?.attributes.last_four_digits}</span>
        </div>
        {signature?.relationships?.status?.attributes?.name === 'active' && <div
          className="cursor-pointer underline text-gray-700 text-hover-primary fs-8 mt-3"
          onClick={() => setOpenPayment(true)}
        >
          Alterar cartão
        </div>}
      </div>
    }

    return 'Desativado';
  }

  const getPeriod = (value) => {
    if (value == 1) {
      return 'Mensalmente';
    }

    return `A cada ${value} meses`;
  }

  useEffect(() => {
    if (!openPayment) {
      getSignature();
    }
  }, [openPayment]);

  // const getBranch = (value) => {
  //   if (value.relationships.origin.type == 'service') {
  //     return value.relationships.origin.relationships.fields[0].relationships.branch

  //   }

  //   if (value.relationships.origin.type == 'plan') {
  //     return value.relationships.origin.relationships.branches[0]
  //   }
  // }

  // const getTypeLabel = (value: any) => {
  //   if (value.relationships.origin.type === 'plan') {
  //     if (value.relationships.origin.attributes.type === 'day_use') {
  //       return 'Day use';
  //     }
  //   }

  //   if (value.relationships.origin.type === 'service') {
  //     if (value.relationships.origin.attributes.modality === 'reservation') {
  //       return 'Locação';
  //     }
  //     if (value.relationships.origin.attributes.modality === 'class') {
  //       return 'Aula';
  //     }
  //   }

  //   return value.relationships.origin.attributes.type;
  // }

  // const getOriginLabel = (value: any) => {
  //   if (value.attributes.type === 'branch') {
  //     return 'Concedido pela unidade';
  //   }
  //   if (value.attributes.type === 'purchase') {
  //     return 'Compra de pacote';
  //   }
  //   if (value.attributes.type === 'refund') {
  //     return 'Reposição';
  //   }

  //   return value.attributes.type;
  // }

  return (
    <>
    <div id="kt_app_content" className="flex-column-fluid">
      <span className="btn btn-md btn-icon btn-bg-light btn-active-color-primary w-100px h-40px cursor-pointer mb-5" onClick={() => navigate('/assinaturas/clubinho')}>
        <i className="las la-arrow-left fw-bold fs-2 text-primary me-3" />
        Voltar
      </span>
      <div className="d-flex flex-column flex-lg-row">
        <div className="flex-lg-row-fluid mb-5 mb-lg-0">
          <div className='card mb-5 mb-sm-0'>
            <div className='card-body pt-5'>
              <div className="justify-content-space-between d-flex mb-5">
                <span className="flex-root text-center fs-2 fw-bold">
                  Detalhes da compra
                </span>
              </div>
              <div className="row mt-10">
                {signature?.relationships?.status?.attributes?.name === 'active' && <div className="col-md-8 col-lg-6 mb-5 mb-md-0 offset-lg-3 offset-md-2">
                  <div className="flex-root justify-content-center text-center">
                    <div className="card border border-1 border-gray-200 bg-gray-300 w-100">
                      <div className="d-flex flex-stack justify-content-center text-center me-2">
                        <Lottie
                          style={{
                            width: 50,
                            height: 50,
                          }}
                          animationData={paymentAnimation}
                          loop={false}
                          autoplay
                          rendererSettings={{
                            preserveAspectRatio: 'xMidYMid slice',
                          }}
                          initialSegment={[0,22]}
                        />
                        <div className="fs-5 opacity-75 fw-bold px-3">
                          Clubinho ativo
                        </div>
                      </div>
                    </div>
                    <div className="fs-6 opacity-50 mt-5">
                      Seu clubinho está ativo, agora é só chamar seus amigos e jogar!
                    </div>
                  </div>
                </div>}

                {signature?.relationships?.status?.attributes?.name === 'pending' && <div className="col-md-8 col-lg-6 mb-5 mb-md-0 offset-lg-3 offset-md-2">
                  <div className="flex-root justify-content-center text-center">
                    <div className="card border border-1 bg-warning p-3 w-100">
                      <div className="d-flex flex-stack justify-content-center text-center me-2">
                        <div className="fs-5 text-gray-100 fw-bold">Clubinho pendente</div>
                      </div>
                    </div>
                    <div className="fs-6 opacity-50 mt-5">Seu clubinho está pendente, quando estiver ativo nós vamos te avisar!</div>
                  </div>
                </div>}

                {signature?.relationships?.status?.attributes?.name === 'canceled' && <div className="col-md-8 col-lg-6 mb-5 mb-md-0 offset-lg-3 offset-md-2">
                  <div className="flex-root justify-content-center text-center">
                    <div className="card border border-1 border-gray-200 bg-gray-300 p-3 w-100">
                      <div className="d-flex flex-stack justify-content-center text-center me-2">
                        <Lottie
                          style={{
                            width: 30,
                            height: 30,
                          }}
                          lottieRef={lottieRef}
                          animationData={paymentRejectedAnimation}
                          loop={false}
                          onDOMLoaded={() => lottieRef.current?.setSpeed(1.4)}
                          autoplay
                        />

                        <div className="fs-5 opacity-75 fw-bold px-3">Clubinho cancelado</div>
                      </div>
                    </div>
                    <div className="fs-6 opacity-50 mt-5">
                      Você ainda pode ver as informações da sua assinatura e suas faturas
                    </div>
                  </div>
                </div>}

                {signature?.relationships?.status?.attributes?.name === 'expired' && <div className="col-md-8 col-lg-6 mb-5 mb-md-0 offset-lg-3 offset-md-2">
                  <div className="flex-root justify-content-center text-center">
                    <div className="card border border-1 border-gray-200 bg-gray-300 p-3 w-100">
                      <div className="d-flex flex-stack justify-content-center text-center me-2">
                        <Lottie
                          style={{
                            width: 30,
                            height: 30,
                          }}
                          lottieRef={lottieRef}
                          animationData={paymentRejectedAnimation}
                          loop={false}
                          onDOMLoaded={() => lottieRef.current?.setSpeed(1.4)}
                          autoplay
                        />

                        <div className="fs-5 opacity-75 fw-bold px-3">Seu clubinho acabou</div>
                      </div>
                    </div>
                    <div className="fs-6 opacity-50 mt-5">
                    Você ainda pode ver as informações da sua assinatura e suas faturas
                    </div>
                  </div>
                </div>}
              </div>

              {signature?.id && <div className="row mt-5">
                <div className="col-md-10 col-lg-10 mb-5 mb-md-0 offset-lg-1 offset-md-1">
                  <div className="justify-content-space-between d-flex mb-2">
                    <span className="flex-root fs-3 fw-bold text-primary">
                      Assinatura
                    </span>
                  </div>
                  <div className='table-responsive'>
                    <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                      <thead>
                        <tr className='border-0'>
                          <th className='p-0 w-140px'></th>
                          <th className='p-0 min-w-140px'></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <span className='text-gray-700 fw-bold mb-1 fs-6'>
                              Início da assinatura
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>
                            {formatLongDateToDate(signature.attributes.start_at, true)}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {signature?.relationships?.status?.attributes?.name !== 'canceled' && <span className='text-gray-700 fw-bold mb-1 fs-6'>
                              {signature?.attributes?.auto_renew && 'Próximo pagamento'}
                              {!signature?.attributes?.auto_renew && 'Término da assinatura'}
                            </span>}
                            {signature?.relationships?.status?.attributes?.name === 'canceled' && <span className='text-gray-700 fw-bold mb-1 fs-6'>
                              Término da assinatura
                            </span>}
                          </td>
                          <td className='text-end text-dark fw-semibold'>
                            {formatLongDateToDate(signature.attributes.finish_at, true)}
                          </td>
                        </tr>
                        {signature?.relationships?.status?.attributes?.name !== 'canceled' && signature?.attributes?.auto_renew && <tr>
                          <td>
                            <span className='text-gray-700 fw-bold mb-1 fs-6'>
                              Renovação automática
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>
                            {getPeriod(signature.relationships.plan.attributes.duration)}
                            <br />
                            Dia {signature.attributes.billing_day}
                          </td>
                        </tr>}
                        {signature?.relationships?.status?.attributes?.name !== 'canceled' && signature?.attributes?.auto_renew && <tr>
                          <td>
                            <span className='text-gray-700 fw-bold mb-1 fs-6'>
                              Forma de pagamento
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>
                            {signature?.relationships?.client_card?.id && getClientCard()}
                            {!signature?.relationships?.client_card?.id && <span
                              className='cursor-pointer underline text-primary text-hover-primary'
                              onClick={() => setOpenPayment(true)}
                            >Adicionar pagamento</span>}
                          </td>
                        </tr>}
                        {signature?.relationships?.status?.attributes?.name === 'canceled' && <tr>
                          <td>
                            <span className='text-gray-700 fw-bold mb-1 fs-6'>
                              Data de cancelamento
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>
                            {formatLongDateToDate(signature.attributes.canceled_at, true)}
                          </td>
                        </tr>}
                        <div className="justify-content-space-between d-flex mb-2 mt-5">
                          <span className="p-0 flex-root fs-3 fw-bold text-primary">
                            Informações
                          </span>
                        </div>
                        <tr>
                          <td>
                            <span className='text-gray-700 fw-bold mb-1 fs-6'>
                              {signature?.relationships?.plan?.relationships?.branches?.length > 1 ? 'Unidades' : 'Unidade'}
                            </span>
                          </td>
                          <td className='text-dark fw-semibold'>
                            {signature?.relationships?.plan?.relationships?.branches?.map(branch => <span className='d-flex justify-content-end'>
                              {branch.attributes.name}
                            </span>)}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className='text-gray-700 fw-bold mb-1 fs-6'>
                              Plano
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>
                            {signature?.relationships?.plan?.attributes?.name}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className='text-gray-700 fw-bold mb-1 fs-6'>
                              Dias válido
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>
                            {parseWeekDays(signature.relationships.plan.attributes.weekdays)}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className='fs-5 text-white fw-bold mb-1'>
                              Valor do plano
                            </span>
                          </td>
                          <td className='fs-5 text-end text-primary fw-bold'>
                            <span>
                              {formatMoney(signature.attributes.price)}
                            </span>
                          </td>
                        </tr>
                        {/* <tr>
                          <td>
                            <span className='text-gray-700 fw-bold mb-1 fs-6'>
                              Aquisição
                            </span>
                          </td>
                          <td className='text-end text-dark fw-semibold'>
                            {getOriginLabel(credit)}
                          </td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>}

              {signature?.id && <div className="row mt-5">
                <div className="col-md-10 col-lg-10 mb-5 mb-md-0 offset-lg-1 offset-md-1">
                    <div className="justify-content-space-between d-flex mb-2">
                      <span className="flex-root fs-3 fw-bold text-primary">
                        Precisa de ajuda?
                      </span>
                    </div>
                    <div className='table-responsive'>
                      <SupportOption
                        originType={'signature'}
                        originId={signature && signature.id}
                        canCancel={!(signature?.relationships?.status?.attributes?.name === 'canceled' || signature?.relationships?.status?.attributes?.name === 'expired')}
                        cancelTitle={'Quero cancelar minha assinatura'}
                        phone={signature?.id && signature?.relationships?.plan?.relationships?.branches?.[0].attributes?.phone}
                        cancel={() => setOpenCancelSignature(true)}
                      />
                    </div>
                  </div>
                </div>}

              {signatures.listLoading === false && !signature?.id && <div className="mb-13 text-center">
                <h2 className="mb-3">
                  Ops, compra não encontrada!
                </h2>
                <div className="text-muted fw-semibold fs-5">
                  Não encontramos a página que você procura!
                </div>
                <div className="text-muted fw-semibold fs-5">
                  Verifique a url ou tente novamente.
                </div>
              </div>}

              {(signatures.listLoading === true) && !signature?.id && <LoadingContent />}
            </div>
          </div>
        </div>

        <div className="flex-lg-auto min-w-lg-400px ms-lg-10">
          {signature?.id && <div className='card mb-5'>
            <div className='card-body pt-5 pb-0 mb-5'>
              <div className="mb-5 text-center">
                <span className="flex-root text-center fs-2 fw-bold mb-3">
                  Faturas
                </span>
              </div>

              <div className="row mt-5">
                <div className="col-lg-12">
                  <div className='table-responsive'>
                    <table className='table table-row-gray-200 align-middle gs-0 gy-4'>
                      <thead>
                        <tr className='border-0'>
                          <th className='p-0 w-140px'></th>
                          <th className='p-0 min-w-140px'></th>
                        </tr>
                      </thead>
                      <tbody>
                        {signature.relationships.invoices.map((invoice: any, index) => <>
                          <tr className='my-0 py-0'>
                            <td className='my-0 py-0'>
                              <span className='d-flex flex-row justify-content-between mb-1 fs-6'>
                                <span className='text-muted fw-bold'>Vigência</span>
                                <span className='d-flex flex-column text-dark fw-semibold'>
                                  {invoice.attributes.start_at === invoice.attributes.finish_at && <span className='d-flex justify-content-end'>
                                    {formatLongDateToDate(invoice.attributes.finish_at)}
                                  </span>}

                                  {invoice.attributes.start_at !== invoice.attributes.finish_at && <>
                                    <span className='d-flex justify-content-end'>
                                      De {formatLongDateToDate(invoice.attributes.start_at)}
                                    </span>

                                    <span className='d-flex justify-content-end'>
                                      Até {formatLongDateToDate(invoice.attributes.finish_at)}
                                    </span>
                                  </>}
                                </span>
                              </span>
                            </td>
                          </tr>
                          <tr className='my-0 py-0'>
                            <td className='my-0 py-0'>
                              <span className='d-flex flex-row justify-content-between mb-1 fs-6'>
                                <span className='text-muted fw-bold'>Valor</span>
                                <span className='text-dark fw-semibold'>
                                  {formatMoney(invoice?.attributes?.price)}
                                </span>
                              </span>
                            </td>
                          </tr>
                          <tr className='my-0 py-0'>
                            <td className='my-0 py-0'>
                              <span className='d-flex flex-row justify-content-between mb-1 fs-6'>
                                <span className='text-muted fw-bold'>Situação</span>
                                <span className='text-dark fw-semibold'>
                                  {invoice.attributes.is_pending && <span className='white'>A vencer</span>}
                                  {invoice.attributes.is_paid && <span className='text-primary'>Pago</span>}
                                  {invoice.attributes.is_canceled && <span className='text-gray-500'>Cancelado</span>}
                                  {invoice.attributes.is_expired && <span className='text-danger'>Vencido</span>}
                                </span>
                              </span>
                            </td>
                          </tr>
                          <tr className='my-0 py-0'>
                            <td className='text-end my-0 py-0'>
                              <span
                                className='btn btn-bg-light btn-active-color-primary px-0 py-2 w-100px align-self-end text-white'
                                onClick={() => navigate(`/faturas/${invoice.id}`)}
                              >
                                Ver fatura
                              </span>
                            </td>
                          </tr>
                          {signature.relationships.invoices.length !== (index+1) && <div className='separator separator-dashed my-3'></div>}

                          {/* <tr>
                            <td className='align-content-start'>
                              <span className='d-flex flex-column text-muted fw-bold mb-1 fs-6'>
                                {invoice.attributes.start_at !== invoice.attributes.finish_at ? <>
                                  <span>Término</span>
                                  <span>Início</span>
                                </> : <span>Data</span>}
                                <span>Situação</span>
                              </span>
                            </td>
                            <td className='d-flex flex-column text-end text-dark fw-semibold'>
                              {invoice.attributes.start_at !== invoice.attributes.finish_at && <span>
                                {formatLongDateToDate(invoice.attributes.finish_at)}
                              </span>}
                              <span>{formatLongDateToDate(invoice.attributes.start_at)}</span>
                              <span>
                                {invoice.attributes.is_pending && <span className='white'>A vencer</span>}
                                {invoice.attributes.is_paid && <span className='text-primary'>Pago</span>}
                                {invoice.attributes.is_canceled && <span className='text-gray-500'>Cancelado</span>}
                                {invoice.attributes.is_expired && <span className='text-danger'>Vencido</span>}
                              </span>
                              <span
                                className='btn btn-bg-light btn-active-color-primary px-0 py-2 w-100px align-self-end text-white'
                                onClick={() => navigate(`/faturas/${invoice.id}`)}
                              >
                                Ver fatura
                              </span>
                            </td>
                          </tr> */}

                          {/* <div className='d-flex text-end'>
                            <span className="btn btn-md btn-icon btn-bg-light btn-active-color-primary w-100px h-40px cursor-pointer mb-5 mt-2" onClick={() => navigate('/assinaturas/clubinho')}>
                              <i className="las la-arrow-right fw-bold fs-2 text-primary me-3" />
                              Pagar
                            </span>
                          </div> */}
                        </>)}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {(signatures.listLoading === true) && !signature?.id && <LoadingBranch />}
            </div>
          </div>}
        </div>
      </div>
    </div>

    <CancelModal
      isOpen={openCancelSignature}
      onClosed={() => setOpenCancelSignature(false)}
      title="Cancelar assinatura"
      text={(signature?.id && signature?.attributes?.auto_renew && signature?.relationships?.client_card?.id) ? <span className='text-gray-800 fw-light'>
        Sua assinatura será válida até <span className='text-white fw-bold'>{signature?.attributes?.finish_at && formatLongDateToDate(signature.attributes.finish_at, true)}</span><br />
        Não será possível renovar sua assinatura após o cancelamento.
      </span> : <span className='text-gray-800 fw-light'>
        Não é possível realizar o cancelamento<br />da sua assinatura de forma automática.<br />
        É necessário que entre em contato com a unidade e solicite o cancelamento, você também pode entrar em contato com nosso suporte para mais informações.
      </span>}
      canCancel={signature?.id && signature?.attributes?.auto_renew && signature?.relationships?.client_card?.id ? true : false}
      button="Cancelar assinatura"
      onChange={() => cancel()}
      isLoading={signatures.actionsLoading === true}
    />

    <PaymentPage
      isOpen={openPayment}
      onClosed={() => setOpenPayment(false)}
      attributes={{
        type: 'signature',
        modality: 'update',
        service: {
          price_total: signature?.attributes?.price,
          price: signature?.attributes?.price,
        },
        id: signature?.id,
        duration: signature?.attributes?.duration,
      }}
    />
  </>)
}

export {
  Signature
};

